import React from "react";
import { defaultAction } from "@actions/defaultAction";
import {
  OPEN_EDIT_PROFILE_MODAL,
  PASSWORD_MODAL_OPEN
} from "@constants/actionTypes";
import styled from "@emotion/styled";
import DefaultCustomButton from "@modules/Components/DefaultCustomButton";
import { useDispatch, useSelector } from "react-redux";

const ProfileMain = styled.div`
  max-width: 670px;

  @media (max-width: 975px) {
    margin: 0 auto;
  }
  @media (max-width: 700px) {
    max-width: 90%;
  }
`;

const ProfileGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 25px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

const GridItem = styled.div`
  border-bottom: ${props => props.borderBottom};
  display: grid;
  align-items: center;
  grid-template-rows: 25px auto;
  padding-bottom: 20px;
  padding-top: 20px;
  padding-left: ${props => props.paddingLeft};

  @media (max-width: 575px) {
    padding-left: 0px;
  }
`;

const Header = styled.div`
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 1px;
  color: rgba(31, 32, 33, 0.5);
`;

const Content = styled.div`
  font-size: 16px;
  color: #1f2021;
`;

const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const NotEntered = styled.div`
  font-size: 16px;
  color: #777984;
  display: flex;
  align-items: center;
  padding-top: 5px;
`;

const Dot = styled.span`
  height: 4px;
  background-color: rgba(119, 121, 132, 0.24);
  width: 4px;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 50%;
`;

const AddSpan = styled.span`
  font-weight: bold;
  color: #ff9c1b;
  cursor: pointer;
`;

const CustomerProfile = () => {
  const dispatch = useDispatch();
  const customerInfo = useSelector(state => state.customerInfo);

  const {
    firstname,
    lastname,
    street,
    street2,
    state,
    city,
    zip,
    email,
    phone
  } = customerInfo;

  const openEditProfileModal = () =>
    dispatch(defaultAction(OPEN_EDIT_PROFILE_MODAL, true));
  return (
    <ProfileMain>
      <ProfileGrid>
        <GridItem
          borderBottom={"1px solid rgba(119, 121, 132, 0.1)"}
          paddingLeft={"25px"}
        >
          <Header>FIRST NAME</Header>
          <Content>
            {firstname ? (
              <>{firstname}</>
            ) : (
              <NotEntered>
                <span>Not entered</span>
                <Dot />
                <AddSpan onClick={openEditProfileModal}>Add</AddSpan>
              </NotEntered>
            )}
          </Content>
        </GridItem>
        <GridItem
          borderBottom={"1px solid rgba(119, 121, 132, 0.1)"}
          paddingLeft={"15px"}
        >
          <Header>LAST NAME</Header>
          <Content>
            {lastname ? (
              <>{lastname}</>
            ) : (
              <NotEntered>
                <span>Not entered</span>
                <Dot />
                <AddSpan onClick={openEditProfileModal}>Add</AddSpan>
              </NotEntered>
            )}
          </Content>
        </GridItem>

        <GridItem
          borderBottom={"1px solid rgba(119, 121, 132, 0.1)"}
          paddingLeft={"25px"}
        >
          <Header>ADDRESS</Header>
          <Content>
            {street ? (
              <>{street}</>
            ) : (
              <NotEntered>
                <span>Not entered</span>
                <Dot />
                <AddSpan onClick={openEditProfileModal}>Add</AddSpan>
              </NotEntered>
            )}
          </Content>
        </GridItem>
        {street2 && (
          <GridItem
            borderBottom={"1px solid rgba(119, 121, 132, 0.1)"}
            paddingLeft={"15px"}
          >
            <Header>ADDRESS LINE 2</Header>
            <Content>{street2}</Content>
          </GridItem>
        )}
        <GridItem
          borderBottom={"1px solid rgba(119, 121, 132, 0.1)"}
          paddingLeft={street2 ? "25px" : "15px"}
        >
          <Header>CITY</Header>
          <Content>
            {city ? (
              <>{city}</>
            ) : (
              <NotEntered>
                <span>Not entered</span>
                <Dot />
                <AddSpan onClick={openEditProfileModal}>Add</AddSpan>
              </NotEntered>
            )}
          </Content>
        </GridItem>
        <GridItem
          borderBottom={"1px solid rgba(119, 121, 132, 0.1)"}
          paddingLeft={!street2 ? "25px" : "15px"}
        >
          <Header>STATE</Header>
          <Content>
            {state ? (
              <>{state}</>
            ) : (
              <NotEntered>
                <span>Not entered</span>
                <Dot />
                <AddSpan onClick={openEditProfileModal}>Add</AddSpan>
              </NotEntered>
            )}
          </Content>
        </GridItem>
        <GridItem
          borderBottom={"1px solid rgba(119, 121, 132, 0.1)"}
          paddingLeft={street2 ? "25px" : "15px"}
        >
          <Header>ZIPCODE</Header>
          <Content>
            {zip ? (
              <>{zip}</>
            ) : (
              <NotEntered>
                <span>Not entered</span>
                <Dot />
                <AddSpan onClick={openEditProfileModal}>Add</AddSpan>
              </NotEntered>
            )}
          </Content>
        </GridItem>
        <GridItem
          paddingLeft={!street2 ? "25px" : "15px"}
          borderBottom={street2 ? "1px solid rgba(119, 121, 132, 0.1)" : ""}
        >
          <Header>PHONE</Header>
          <Content>
            {phone ? (
              <>{phone}</>
            ) : (
              <NotEntered>
                <span>Not entered</span>
                <Dot />
                <AddSpan onClick={openEditProfileModal}>Add</AddSpan>
              </NotEntered>
            )}
          </Content>
        </GridItem>
        <GridItem paddingLeft={street2 ? "25px" : "15px"}>
          <Header>EMAIL</Header>
          <Content>{email}</Content>
        </GridItem>
      </ProfileGrid>
      <ButtonGrid>
        <DefaultCustomButton
          handleClick={openEditProfileModal}
          classes={"main-default-orange-button"}
          type="button"
          disabled={false}
          buttonType={"WHITE_BUTTON_ORANGE_COLOR"}
          name="submit"
        >
          <span>Edit Profile</span>
        </DefaultCustomButton>
        <DefaultCustomButton
          handleClick={() => dispatch(defaultAction(PASSWORD_MODAL_OPEN, true))}
          classes={"main-default-orange-button"}
          type="button"
          disabled={false}
          buttonType={"WHITE_BUTTON_ORANGE_COLOR"}
          name="submit"
        >
          <span>Change Password</span>
        </DefaultCustomButton>
      </ButtonGrid>
    </ProfileMain>
  );
};

export default CustomerProfile;
